import { FC, useMemo } from 'react';
import { useQuery } from 'react-query';
import { QueryKey } from '@/lib/query-client';
import { getAllPrivateModels } from '@/lib/services/private-model.service';
import ModelOption from '@/components/model-option';
import OnOffList from '../on-off-list';
import { FormProps } from '../helpers';
import { ModelEntity } from '@/lib/models/policy-model/portal';

interface Props extends FormProps {
  value: ModelEntity[] | undefined;
  onChange: (models: ModelEntity[] | undefined) => void;
  defaultModelId?: string;
}

const ModelEntityList: FC<Props> = ({ value, onChange, defaultModelId, ...rest }) => {
  const query = useQuery([QueryKey.PrivateModelsList], async () => getAllPrivateModels());
  const { data: privateModels } = query;

  const modelOptions = useMemo(() => {
    return (privateModels || []).map(({ name, id, modelId }) => {
      const isDefault = id === defaultModelId;
      const tooltip = isDefault ? 'The default model must be enabled' : '';

      return {
        label: <ModelOption name={name} modelId={modelId} />,
        labelSimple: name,
        value: id,
        disabled: isDefault,
        tooltip,
      };
    });
  }, [privateModels, defaultModelId]);

  return (
    <OnOffList
      {...rest}
      value={value}
      onChange={onChange}
      options={modelOptions}
      idField="modelId"
      search
      emptyMessage="No private models available"
    />
  );
};

export default ModelEntityList;
